import React from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

export default function FilterPills({
  key,
  pillName,
  deleteFilter,
  filterName,
}: {
  key: string
  pillName: any
  deleteFilter: any
  filterName: string
}) {
  return (
    <div
      key={key}
      className='d-inline-block d- border rounded p-1 px-2 background-color-drag mx-1 my-1'
    >
      <div className='d-flex gap-1'>
        <div>
          <p className='m-0 font-weight-500'>{filterName}</p>
          <p className='m-0'>{pillName}</p>
        </div>
        <img
          onClick={() => {
            deleteFilter(pillName)
          }}
          src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
          alt='garbage icon'
          className='cursor-pointer'
        />
      </div>
    </div>
  )
}
